<template>
  <div>
    <div class="informational-banner members bright-blue hidden-print">
      <i
        id="dismiss-promotion-banner"
        class="hi hi-close hi-10"
        @click="handleClose"
      />

      <div class="wrapper">
        <div class="content">
          <h4 class="title">
            Contractor Compliance in Hubstaff
          </h4>

          <span class="description">
            Concerned with compliance regulations for your global contractors?
            <br>
            Simplify people management by adding contracts for new or existing team members directly into Hubstaff.
          </span>

          <div class="ctas">
            <a
              href="#"
              class="btn btn-sm primary-cta"
              @click.prevent="handleCtaClick('generate_contracts')"
            >
              Generate Contracts
            </a>

            <a
              href="#"
              class="btn btn-sm secondary-cta"
              @click.prevent="handleCtaClick('upload_contracts')"
            >
              Upload Contracts
            </a>

            <div class="dismiss">
              <AppCheckbox v-model="dontShowAgain"> Don't show this again </AppCheckbox>
            </div>
          </div>
        </div>

        <div class="illustration-wrapper">
          <img
            class="illustration"
            :src="illustrationSrc"
          />
        </div>
      </div>
    </div>

    <ContractorComplianceDialog
      ref="dialog"
      :organization-id="organizationId"
    />
  </div>
</template>

<script>
import { CONTRACTOR_COMPLIANCE_BANNER_ILLUSTRATION } from '~/rails_assets';
import { UserOrganizationsResource } from '~/resources';
import ContractorComplianceDialog from './ContractorComplianceDialog.vue';

export default {
  name: 'ContractorComplianceBanner',
  components: {
    ContractorComplianceDialog,
  },
  props: {
    organizationId: {
      type: Number,
      required: true,
    },
    userOrganizationId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    dontShowAgain: false,
    illustrationSrc: CONTRACTOR_COMPLIANCE_BANNER_ILLUSTRATION,
  }),
  mounted() {
    this.trackBannerViewed();
  },
  methods: {
    trackBannerViewed() {
      window.analytics?.track('Viewed INOV001 Compliance Banner', {
        organization_id: this.organizationId,
      });
    },
    handleCtaClick(ctaLabel) {
      this.trackBannerClick(ctaLabel);
      this.$refs.dialog?.open();
    },
    async handleClose() {
      this.trackBannerClick('close');

      if (this.dontShowAgain) {
        this.trackBannerClick('dont_show_again');
        await this.dismissBanner();
      }

      this.$emit('close');
    },
    async dismissBanner() {
      try {
        const payload = {
          dismiss: {
            feature: 'contractor_compliance_inov001',
            promotion_type: 'info_banner',
            dismissed_item: 'members',
          },
        };
        const response = await UserOrganizationsResource.dismissPromotion(
          { id: this.userOrganizationId },
          payload,
          { abortReload: true },
        );

        if (response?.errors) {
          this.$appMessage('Error dismissing banner.');
        }
      } catch (error) {
        if (![401, 403].includes(error.status)) {
          this.$appMessage('Unexpected error. Please try again.');
        }
      }
    },
    trackBannerClick(ctaLabel) {
      window.analytics?.track('Clicked INOV001 Compliance Banner', {
        cta_label: ctaLabel,
        organization_id: this.organizationId,
      });
    },
  },
};
</script>
